/**
 * Product Helper Functions
 * Ported from legacy nv-nav-cart-build (lines 2111-2197)
 */

import nvCartTranslations from "../translations/nvCartTranslations";

// Extend Window interface for global access
declare global {
  interface Window {
    nvProductHelpers?: any;
    locale?: string;
  }
}

/**
 * Check if product has reached its purchase limit
 */
const productLimitReached = function (cart: any[], productId: string | number): boolean {
  const cartItemValue = findProductById(cart, productId);
  
  if (!cartItemValue) {
    return false;
  }
  
  if (cartItemValue.quantity < cartItemValue.limitPerCustomer) {
    return false;
  } else {
    return true;
  }
};

/**
 * Check if product is out of stock
 */
const productOutOfStock = function (cart: any[], productId: string | number): boolean {
  let quantity: number | undefined;
  
  cart.filter(function (product) {
    if (product.id == productId) {
      quantity = product.quantity;
    }
  });

  if (quantity === 0) {
    return true;
  }

  return false;
};

/**
 * Check if product has available stock
 */
const availableStock = function (cart: any[], productId: string | number): boolean {
  let quantity: number | undefined;
  let originalQuantity: number | undefined;
  
  cart.filter(function (product) {
    if (product.id == productId) {
      quantity = product.quantity;
      originalQuantity = product.originalQuantity;
    }
  });

  if (quantity !== undefined && quantity > 0 && 
      originalQuantity !== undefined && originalQuantity > quantity) {
    return true;
  }
  
  return false;
};

/**
 * Get product stock message for translations
 */
const getProductStockMessage = function (
  productDetails: any[], 
  productId: string | number, 
  type: string
): string {
  const nvCartTrans = (window as any).nvCartTrans;
  const locale = (window as any).locale || 'en-us';
  
  const productStockCount = productDetails.filter(function (a) {
    return a.id == productId;
  })[0].limitPerCustomer;
  
  if (type === "DOWNLOAD") {
    return nvCartTranslations.translations.giftCardProductLimitReached[locale]
      .replace("{x}", productStockCount);
  } else {
    return nvCartTranslations.translations.productLimitReached[locale]
      .replace("{x}", productStockCount);
  }
};

/**
 * Get product out of stock message
 */
const getProductOutOfStockMessage = function (
  productDetails: any[], 
  productId: string | number
): string {
  const locale = (window as any).locale || 'en-us';
  
  return nvCartTranslations.translations.outOfStock[locale];
};

/**
 * Get available stock message
 */
const getAvailableStockMessage = function (
  productDetails: any[], 
  productId: string | number
): string {
  const locale = (window as any).locale || 'en-us';
  
  return nvCartTranslations.translations.productAvailabilityReached[locale];
};

/**
 * Find a product by its ID in the products array
 */
const findProductById = function (
  products: any[] | undefined, 
  productId: string | number | undefined
): any | null {
  if (products === undefined || productId === undefined) {
    return null;
  }
  
  const matchedProducts = products.filter(function (product) {
    return product.id == productId;
  });
  
  return matchedProducts.length === 0 ? null : matchedProducts[0];
};

/**
 * Export nvProductHelpers object
 */
export const nvProductHelpers = {
  productLimitReached,
  getProductStockMessage,
  productOutOfStock,
  getProductOutOfStockMessage,
  availableStock,
  getAvailableStockMessage,
  findProductById,
};

// Make nvProductHelpers available globally for legacy compatibility
if (typeof window !== 'undefined') {
  if (window.nvProductHelpers == null) {
    window.nvProductHelpers = nvProductHelpers;
  }
}

export default nvProductHelpers;

